import React from 'react';
import SaveIcon from '@mui/icons-material/Save';
import { FormGroup, Button } from '@mui/material';
import { useStyles } from '../Styles';
import PropTypes from 'prop-types';

export default function SaveButtonCustom(props) {
  const classes = useStyles();

  return (
    <FormGroup>
      <Button
        style={{ borderRadius: '15px' }}
        className={classes.saveButton}
        variant="contained"
        color="primary"
        size="large"
        type="submit"
        disabled={props.disabled}
        startIcon={<SaveIcon />}
        onClick={props.onClick}
      >
        Salvar
      </Button>
    </FormGroup>
  );
}

SaveButtonCustom.defaultProps = {
  props: { disabled: false, onClick: () => { } },
};

SaveButtonCustom.propTypes = {
  /** Props é usado para passar o onClick(função que vai ser executada quando clicar),
   * e disabled que é para mostrar ou não o botão.
   */
  props: PropTypes.object,
};
